import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { RuntimeConfigService } from './runtime-config.service';

export function moduleGuard(
  moduleCode: string,
): CanActivateFn {
  return (_route, state) => {
    const runtime = inject(RuntimeConfigService);
    const router = inject(Router);

    return runtime.ensureLoaded().pipe(
      map(() => {
        const module = runtime.module(moduleCode);

        if (
          module
          && module.habilitado
          && module.disponivelProduto
        ) {
          return true;
        }

        const reason =
          module && !module.disponivelProduto
            ? 'NAO_DISPONIVEL'
            : 'NAO_HABILITADO';

        return router.createUrlTree(
          ['/modulo-indisponivel'],
          {
            queryParams: {
              modulo: moduleCode,
              motivo: reason,
              returnUrl: state.url,
            },
          },
        );
      }),
    );
  };
}

/**
 * Permite acesso a capacidades compartilhadas quando pelo menos um dos módulos
 * consumidores estiver habilitado. Ex.: Pessoas e Entidades é usado tanto por
 * Processos quanto por Mediação e Conciliação.
 */
export function anyModuleGuard(moduleCodes: string[]): CanActivateFn {
  return (_route, state) => {
    const runtime = inject(RuntimeConfigService);
    const router = inject(Router);

    return runtime.ensureLoaded().pipe(
      map(() => {
        const available = moduleCodes.some((code) => {
          const module = runtime.module(code);
          return !!module && module.habilitado && module.disponivelProduto;
        });

        if (available) return true;

        return router.createUrlTree(
          ['/modulo-indisponivel'],
          {
            queryParams: {
              modulo: moduleCodes.join(','),
              motivo: 'NAO_HABILITADO',
              returnUrl: state.url,
            },
          },
        );
      }),
    );
  };
}
